import { IAdminLogConfirmOk, IAdminLogsToConfirm, ILogPub } from "@api/admin.int";
import { Box, BoxProps, Button, Heading, Stack, useBoolean } from "@chakra-ui/react";
import { useVVApi } from "components/api";
import { DeepErrorBox } from "components/misc";
import { useVVStore } from "components/store";
import { formatDateTime } from "components/utils";
import { VizvCard, VizvCardHeaderPopup, VizvMainCol } from "components/vizvComponents";
import { NavMainLink } from "features/NavMain";
import React, { createContext, useEffect, useMemo, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router";
import { NYIL_BTN } from "theme";

export interface IAdminOption {
	title: string;
	action: () => void;
}

export interface IAdminContext {
	isAdmin: boolean;
	options: IAdminOption[];
}

export const AdminContext = createContext<IAdminContext>({
	isAdmin: false,
	options: [],

})


export function AdminLayout() {
	return <Outlet />

}


export function AdminLogsToConfirm() {
	const nav = useNavigate();
	const navBack = '/map';
	const isDetailed = false;

	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useBoolean(false);
	const api = useVVApi();
	const [logs, setLogs] = useState<ILogPub[]>([]);
	const [selected, setSelected] = useState<ILogPub>();

	useEffect(() => {


		(async () => {
			setError('');
			setIsLoading.on();
			try {
				const resp = await api.fetch<IAdminLogsToConfirm>({
					url: '/admin/logs/to-confirm', method: 'GET'
				});
				setLogs(resp.logs);

			} catch (ex) {
				setError(ex + '');
			} finally {
				setIsLoading.off();
			}
		})();

	}, []);

	const adminCtx = useMemo<IAdminContext>(() => ({
		isAdmin: true,
		options: [{
			title: "Jóváhagyom",
			action: () => alert("Hello")
		}]
	}), []);

	const itemClick = (logItem: ILogPub) => {
		console.log(logItem);
		setSelected(logItem);
	}


	const onConfirmOK = async (logItem: ILogPub) => {
		setError('');
		setIsLoading.on();
		try {
			await api.fetch<IAdminLogConfirmOk>({
				url: '/admin/logs/to-confirm/ok', method: 'POST',
				payload: { logPk: (logItem as any).pk, logSk: (logItem as any).sk }
			});
			setLogs(logs.filter(log => log !== logItem));
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}


	return <><VizvMainCol
		isTool={{ width: 400, isDetailed }} mapNavRoot={'/admin/logs-to-confirm'}
	>
		<VizvCard
			isTool
			{...navBack && { onBack: () => nav(navBack) }}
			isClosable
			mr={5} mt={5}
			maxHeight="calc(100vh - 4em)"
		>
			<DeepErrorBox isLoading={isLoading} error={error} />
			<VizvCardHeaderPopup fontSize='x-large' fontWeight='400' variant="blue" mb={2}
			//{...parent && { mt: 0 }}
			>
				Jóváhagyás
			</VizvCardHeaderPopup>
			s:{selected?.logAction}
			<Stack p={2} pb={4} gap={2} >
				{logs.map((log, lix) => <Box key={lix} onClick={() => itemClick(log)}
						_hover={{bg:'#000'}}
						{...log===selected && { bg:'#333'}}
					
					>
					{(log as any).info && (log as any).info.affairKey ? <NavMainLink
						to={`/admin/logs-to-confirm/affair/${(log as any).info.affairKey}`}
						>{log.logAction}</NavMainLink>
					: <NavMainLink
						to={`/admin/logs-to-confirm`}
						>{log.logAction}</NavMainLink>
					}
					<Box fontSize='xs' lineHeight='normal'>
						{log.user && <Box>{log.user.userName}</Box>}
						{log.createdAt && <Box>{formatDateTime(log.createdAt)}</Box>}
					</Box>
					{log===selected && <Box>
						<Button colorScheme="green" size='xs' onClick={() => onConfirmOK(log)}>Jóváhagyom</Button>
					</Box>}
				</Box>)}
				{/*logs.map((log, lix) => <Box key={lix} onClick={() => itemClick(log)}>
					<AdminLogsToConfirmItem logItem={log} isSelected={log === selected} onClick={l => setSelected(l)} onConfirmOK={onConfirmOK} />

				</Box>)*/}
			</Stack>



		</VizvCard>
	</VizvMainCol>
		<AdminContext.Provider value={adminCtx}>
			<Outlet />
		</AdminContext.Provider>
	</>
}

export interface AdminLogsToConfirmItemProps {
	logItem: ILogPub;
	isSelected: boolean;
	onClick: (v: ILogPub) => void
	onConfirmOK: (v: ILogPub) => void
}

export function AdminLogsToConfirmItem({ logItem, isSelected, onClick, onConfirmOK }: AdminLogsToConfirmItemProps) {
	switch (logItem.logAction) {
		case 'affair-create':
			const li = logItem as any;
			if (!li.info || !li.info.affairKey)
				return <Box color='red'>{logItem.logAction} : no affair key</Box>;
			return <AdminNavLink isSelected={isSelected} onClick={() => onClick(logItem)}
				to={`/admin/logs-to-confirm/affair/${(logItem as any).info.affairKey}`}
				actions={<>
					<Button colorScheme="green" size='xs' onClick={() => onConfirmOK(logItem)}>Jóváhagyom</Button>
				</>}
			>
				{logItem.logAction} {logItem.user.userName}
			</AdminNavLink>
		default:
			return <Box color='red'>{logItem.logAction}</Box>
	}
}

export interface AdminNavLinkProps extends BoxProps {
	isSelected: boolean;
	to?: string;
	actions?: React.ReactNode;
}

export function AdminNavLink({ children, isSelected, onClick: pOnClick, to, actions, ...rest }: AdminNavLinkProps) {
	const isMobile = useVVStore(state => state.isMobile());
	const setLayoutPush = useVVStore(state => state.setLayoutPush);

	const onClick = (e: React.MouseEvent<any>) => {
		if (pOnClick) {
			if (!to)
				e.preventDefault();
			pOnClick(e);
		} else {
			if (isMobile)
				setLayoutPush('menu');
		}
	}

	//const isActive = location.pathname === to;

	return <Box>
		<NavLink to={to || ''}
			onClick={onClick}
		><Heading
			position='relative' left={0}
			display='flex' flexDir='row' alignItems='center' gap={1}
			background='#fff1'
			color='#d2ddd9'

			{...isMobile ? { fontWeight: '400', fontSize: 'lg' } : { fontWeight: '400', fontSize: 'md' }}

			p={2}
			_hover={{ textDecor: 'none', left: '0.2em', background: '#fff2', color: '#fff' }}
			{...isSelected && {
				background: 'secondary.main', color: '#000', fontWeight: 500, left: '1em',
				_hover: { left: '1.2em' }
			}}
			transition={`background-color .15s ease-out, color .15s ease-out, left .15s ease-out`}
			{...rest}


		>{children}
				<Box ml='auto' w='18px'>{isSelected && <Box as='span' fontFamily='initial' >{NYIL_BTN}</Box>}</Box>
			</Heading>
		</NavLink>
		{actions && isSelected && <Box display='flex' flexDir='row' alignItems='center' justifyContent='space-evenly' mt={2}>
			{actions}
		</Box>}
	</Box>
}


